import { createContext, ReactNode, useContext } from 'react';
import { useAccountState } from '../hooks/account/useAccountState';

export type AccountContextType = ReturnType<typeof useAccountState>;

const AccountContext = createContext<AccountContextType | null>(null);

export const AccountProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const accountState = useAccountState();

  return (
    <AccountContext.Provider value={accountState}>
      {children}
    </AccountContext.Provider>
  );
};

export const useAccountContext = (): AccountContextType => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used within an AccountProvider');
  }
  return context;
};
